<template>
  <div>
    <SiteHeader />
    <div class="page flex-col">
      <img
        class="image_1"
        referrerpolicy="no-referrer"
        src="./assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png"
      />
      <div class="box_1 flex-col">
      <div class="text-wrapper_1 flex-col"><span class="text_8">学术成果掠影</span></div>
      <div class="text-wrapper_2">
        <span class="text_9">首页&nbsp;&gt;&nbsp;学科与科研&nbsp;&gt;</span>
        <span class="text_10">学科建设&nbsp;&gt;&nbsp;学术成果掠影</span>
      </div>
      <div class="box_3 flex-col">
        <div class="image-text_1 flex-row justify-between">
          <div class="group_3 flex-col"></div>
          <span class="text-group_1">马克思主义新闻观</span>
        </div>
        <div class="group_4 flex-col">
          <div class="text-wrapper_3 flex-col">
            <span class="text_11">
              《中国共产党新闻工作文件汇编》（上、中、下卷），中国社会科学院新闻研究所编，新华出版社，1980&nbsp;年
            </span>
          </div>
        </div>
        <div class="group_5 flex-row">
          <img
            class="thumbnail_2"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPngfa44d477f810800c79c1475efbbab7b1c27f29bafcb86b410bda7b2b05ba315b.png"
          />
          <div class="box_4 flex-col"></div>
          <div class="box_5 flex-col"></div>
          <div class="box_6 flex-col"></div>
          <div class="box_7 flex-col"></div>
          <img
            class="thumbnail_3"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPnga69ef0377538c130ef587f75f5590ed2cf9b11f70395c88e486fa50877499fdf.png"
          />
        </div>
        <div class="image-text_2 flex-row justify-between">
          <div class="group_6 flex-col"></div>
          <span class="text-group_2">新闻理论</span>
        </div>
        <div class="group_7 flex-row">
          <div class="section_1 flex-col">
            <img
              class="image_2"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPngb933c4810e22c77582a0d14344830e017bc0c382ecd9f4767c24ea7f54193cab.png"
            />
            <span class="paragraph_1">
              &nbsp;《新闻论集》，安岗著，
              <br />
              天津人民出版社，1982&nbsp;年
            </span>
            <img
              class="thumbnail_4"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng6bbcd424ff3f6d3d590012e7289d478b97d5a2f10c28bd454d1364ed6ae811bb.png"
            />
          </div>
          <div class="section_2 flex-col"></div>
          <div class="section_3 flex-row">
            <span class="paragraph_2">
              &nbsp;《各国新闻出版法选辑》，中国社会科学院新闻研究所&nbsp;等编，人民日报出版社，1981&nbsp;年
              <br />
              <br />
              《各国广播电视法选辑》，钱辛波、姜宇辉、张宗厚、曾美云编，群众出版社，1984&nbsp;年
              <br />
              <br />
              《各国新闻出版法选辑》（续编），中国社会科学院新闻研究所、北京新闻学会等编，人民日报出版社，1987&nbsp;年
            </span>
            <img
              class="thumbnail_5"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPngf04296643e70e9b96c22e583e17caa1dad44d9384473534e12d3f05315db09f0.png"
            />
          </div>
        </div>
        <div class="group_8 flex-row justify-between">
          <div class="box_8 flex-col"></div>
          <div class="box_9 flex-col"></div>
          <div class="box_10 flex-col"></div>
          <div class="box_11 flex-col"></div>
        </div>
        <div class="group_9 flex-row">
          <span class="text_12">&nbsp;《新闻侵权与诉讼》，孙旭培主编，人民日报出版社，1994&nbsp;年</span>
          <img
            class="thumbnail_6"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng6bbcd424ff3f6d3d590012e7289d478b97d5a2f10c28bd454d1364ed6ae811bb.png"
          />
          <span class="text_13">
            &nbsp;《张力与限制——新闻法治与自律的比较研究》，张西明著，重庆出版社，2002&nbsp;年
          </span>
          <img
            class="thumbnail_7"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng6bbcd424ff3f6d3d590012e7289d478b97d5a2f10c28bd454d1364ed6ae811bb.png"
          />
          <span class="text_14">
            &nbsp;《媒介消费之讼——中国内地案例重述与释解》，宋小卫著，中国社会科学出版社，2009&nbsp;年
          </span>
          <img
            class="thumbnail_8"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng6bbcd424ff3f6d3d590012e7289d478b97d5a2f10c28bd454d1364ed6ae811bb.png"
          />
          <span class="text_15">&nbsp;《喻权域文集》，喻权域著，上海辞书出版社，2005&nbsp;年</span>
          <img
            class="thumbnail_9"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng6bbcd424ff3f6d3d590012e7289d478b97d5a2f10c28bd454d1364ed6ae811bb.png"
          />
        </div>
      </div>
      <SiteFooter :notch-width="1300" notch-left="calc((100vw - 1300px) / 2)" />
      </div>
    </div>
  </div>
</template>
<script>
import SiteHeader from '@/components/SiteHeader.vue';
import SiteFooter from '@/components/SiteFooter.vue';

export default {
  components: {
    SiteHeader,
    SiteFooter
  },
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />
